<style>
    .c-week-selector .c-popover-selector, .c-popover-selector {
        border:none;
    }
</style>
<template>
    <div class="c-week-selector">
        <b-button-group>
            <b-button @click="reset" class="btn btn-light mr-1">{{Core.Definition.getDefinition('Auj.')}}</b-button>
            <b-button @click="minus" class="btn btn-info"><i class="fa fa-chevron-left"></i></b-button>
            <b-button class="btn btn-light">{{Vue.moment(dataValue.end).format(options.date.displayFormat)}}</b-button>
            <b-button @click="plus" class="btn btn-info"><i class="fa fa-chevron-right"></i></b-button>
            <b-button id="popoverDate"  class="btn btn-light mr-1"><i class="fa fa-calendar"></i></b-button>
        </b-button-group>
        <b-popover placement="bottom" class="text-center c-popover-selector" ref="popoverDate" target="popoverDate">
            <InputDatePicker
                    :isInline="true"
                    v-model="dataDate">
            </InputDatePicker>
        </b-popover>
    </div>
</template>

<script>
    import InputDatePicker from './InputDatePicker'
    import Vue from 'vue'

    Vue.use(require('vue-moment'))
    export default {
        name: 'MonthPagination',
        components: {
            InputDatePicker
        },
        props: {
            options: {
                type: Object,
                default: function () {
                    return {
                        date: {
                            displayFormat: 'MMM YYYY'
                        }
                    }
                }
            },
            value: {
                type: Object,
                default: function () {
                    return {
                        start: '',
                        end: ''
                    }
                }
            }
        },
        watch: {
            value(val) {
                this.dataValue = val
            },
            dataValue: {
                handler(val) {
                    this.$refs.popoverDate.$emit('close')
                    this.$emit('input', val)
                },
                deep: true
            },
            dataDate(val) {
                this.dataValue.start = Vue.moment(val).startOf('month').format('YYYY-MM-DD')
                this.dataValue.end = Vue.moment(val).endOf('month').format('YYYY-MM-DD')
            }
        },
        mounted() {
            this.reset()
        },
        data: () => {
            return {
                Vue: Vue,
                Core: window.Core,
                dataValue: {
                    start: '',
                    end: ''
                },
                dataDate: new Date()
            }
        },
        methods: {
            plus() {
                let startOf = 'month'
                this.dataValue.start = Vue.moment(this.dataValue.start).add(startOf, 1).startOf(startOf).format('YYYY-MM-DD')
                this.dataValue.end = Vue.moment(this.dataValue.end).add(startOf, 1).endOf(startOf).format('YYYY-MM-DD')
            },
            minus() {
                let startOf = 'month'
                this.dataValue.start = Vue.moment(this.dataValue.start).add(startOf, -1).startOf(startOf).format('YYYY-MM-DD')
                this.dataValue.end = Vue.moment(this.dataValue.end).add(startOf, -1).endOf(startOf).format('YYYY-MM-DD')
            },
            reset() {
                let startOf = 'month'
                this.dataDate = new Date()
                this.dataValue.start = Vue.moment().startOf(startOf).format('YYYY-MM-DD')
                this.dataValue.end = Vue.moment().endOf(startOf).format('YYYY-MM-DD')
            }
        }
    }
</script>